import React, { useMemo, useContext } from 'react'
import { Box, Paragraph, ChevronLink } from '@telus-uds/components-web'
import { useCookies } from 'react-cookie'
import { object } from 'prop-types'

import localeContext from '../../../../contexts/Locale'
import useTranslate from '../../../../hooks/useTranslate'
import useAuthentication from '../../../../hooks/useAuthentication'
import { getEmailYourCartLink, checkShouldRenderEmailYourCart, isCartCreatedByAgent } from './utils'
import useFeatureFlags from '../../../../hooks/useFeatureFlags'

const EmailYourCartLink = ({ cart }) => {
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const [cookies] = useCookies()
  const { data: featureFlags } = useFeatureFlags()
  const isAuthenticated = useAuthentication()

  const saveCartLink = getEmailYourCartLink(cart, lang)

  const getEmailCartCTA = () => {
    return translate(`priceSummary.${isCartCreatedByAgent(cart) ? 'emailQuote' : 'emailYourCart'}`)
  }
  const shouldRenderLink = useMemo(
    () => checkShouldRenderEmailYourCart(cart, cookies, isAuthenticated, featureFlags),
    [cart, cookies, isAuthenticated]
  )
  if (!shouldRenderLink) {
    return null
  }

  return (
    <Box>
      <Paragraph align="center">
        <ChevronLink data-test-id="email-your-cart" href={saveCartLink}>
          {getEmailCartCTA()}
        </ChevronLink>
      </Paragraph>
    </Box>
  )
}

EmailYourCartLink.propTypes = {
  cart: object.isRequired
}

export default EmailYourCartLink
